<template>
  <div class="card-body">
    <div class="card height-auto v-application--is-ltr text-left">
      <div class="card-body">
        <v-row class="headerTable-div">
          <v-col md="4" sm="12">
            <p class="title main-color" style="text-align: left">
              {{ page_title }}
            </p>
            <p
              class="font-weight-bold small"
              style="text-align: left"
              v-if="breadcrumb"
            >
              {{ breadcrumb }}
            </p>
          </v-col>
        </v-row>
        <v-row class="mb-7">
          <v-col md="5" cols="12">
            <!-- Class -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Class</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Class')"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  v-model="selectedClass"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider
          style="background-color: #ddd !important; margin-bottom: 20px"
          class="mt-4 mb-4 main-color"
        ></v-divider>
        <v-row>
          <!-- students class -->
          <v-col v-if="items.length > 0" cols="12" md="6">
            <div class="row actions-container mt-5 mb-7">
              <div class="actions">
                <v-icon
                  v-if="!edit_mode"
                  :title="$t('Edit')"
                  style="cursor: pointer"
                  class="main-color edit-icon"
                  @click="edit_mode = true"
                  >edit</v-icon
                >
                <span
                  v-if="edit_mode"
                  class="main-color pr-3"
                  style="cursor: pointer"
                  @click="update()"
                  >{{ $t("Save") }}</span
                >
                <span
                  v-if="edit_mode"
                  style="color: #646464; cursor: pointer"
                  @click="cancel()"
                  >{{ $t("Cancel") }}</span
                >
              </div>
            </div>

            <!-- Sample Table View Mode -->
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" v-if="edit_mode">
                      <!-- <v-checkbox @click="selectAll()"></v-checkbox> -->
                    </th>
                    <th class="text-left">
                      {{ $t("Students") }}
                    </th>

                    <th
                      class=""
                      :style="
                        edit_mode
                          ? 'text-align: center !important'
                          : 'text-align: left !important'
                      "
                    >
                      {{ $t("Exam") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="edit_mode">
                    <th class="text-left">
                      <v-checkbox @click="selectAll()"></v-checkbox>
                    </th>
                    <th class="text-left">
                      {{ $t("All Class") }}
                      <p class="red--text" v-if="showErrorMessageStudentSelect">
                        {{ $t("Shoud be Select one student at least") }}
                      </p>
                    </th>

                    <th class="text-left"></th>
                  </tr>
                  <tr v-for="item in items" :key="item">
                    <td v-if="edit_mode">
                      <v-checkbox
                        v-if="item.can_edit"
                        v-model="item.selected"
                      ></v-checkbox>
                    </td>
                    <td>
                      {{ item.name }}
                    </td>

                    <td>{{ item.exam_name }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <!-- grade -->
          <v-col v-if="showSelectExamOnGrade" cols="12" md="6">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("All Grade") }}
                    </th>
                    <th class="text-left">
                      <!-- <v-autocomplete
                        :label="$t('Select Exam')"
                        :items="exams"
                        item-text="name"
                        item-value="id"
                        v-model="selectedExam"
                        solo
                      ></v-autocomplete> -->
                      <!-- <div>
                        <p
                          class="red--text"
                          v-if="showErrorMessageForSelectExam"
                        >
                          {{ $t("Should Be Select Exam") }}
                        </p>
                      </div> -->
                      {{ exam_name }}
                    </th>

                    <th class="text-left">
                      <span
                        v-if="edit_mode_grade"
                        class="main-color pr-3"
                        style="cursor: pointer"
                        @click="updateExamOnGrade()"
                        >{{ $t("Save") }}</span
                      >
                      <span
                        v-if="edit_mode_grade"
                        style="color: #646464; cursor: pointer"
                        @click="cancelTow()"
                        >{{ $t("Cancel") }}</span
                      >
                      <v-btn
                        class="modal-btn-save saveBtn"
                        @click="edit_mode_grade = true"
                        v-if="!edit_mode_grade"
                        >{{ $t("Bulk Assign") }}</v-btn
                      >
                    </th>
                  </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-col>
          <v-col md="6" cols="12"></v-col>
        </v-row>
      </div>
    </div>
    <v-snackbar
      v-model="snack"
      :timeout="snackTime"
      :color="snackColor"
      :right="true"
      :top="true"
    >
      <!-- {{ snackText }} -->

      <span class="white--text">{{ snackText }}</span>

      <v-btn text @click="snack = false">{{ $t("Close") }}</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="showBulkAssignMessage"
      persistent
      max-width="320"
      class="dialog_confirm"
    >
      <v-card>
        <v-card-title class="headline">{{ $t("Message") }}</v-card-title>

        <v-card-text>{{
          $t(
            "You cannot perform bulk assign because one or more Students have confirmed marks for this Act."
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="modal-btn-cancel noBtn"
            @click="showBulkAssignMessage = false"
            id="noBtn"
            ref="always_focus"
            >{{ $t("close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
// import addEditExamComponent from "../../components/modals/addEditExamComponent";
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "Exams",
  // components: { addEditExamComponent },
  mixins: [validationMixin],
  data() {
    return {
      snackTime: 3000,
      snackColor: "success",
      selectAllStudent: false,
      showBulkAssignMessage: false,
      snackText: "",
      snack: false,
      page_title: "General Exam Assignment",
      academic_grade_year_id: "",
      exam_id: "",
      breadcrumb: "",
      exam_name: "",
      //   selectedQuarter: "",
      //   selectedSubject: "",
      //   selectedGrade: "",
      //   selectedQualifier: "",
      //   selectedActivity: "",
      selectedClass: "",
      selectedExam: "",
      edit_mode: false,
      edit_mode_grade: false,
      showErrorMessageForSelectExam: false,
      showErrorMessageStudentSelect: false,
      showSelectExamOnGrade: false,

      classes: [],
      items: [],

      selected: [],
    };
  },
  watch: {
    // selectedQuarter: {
    //   handler() {
    //     this.getGrades();
    //   },
    //   deep: true,
    // },
    selectedClass: {
      handler() {
        if (this.selectedClass != "" && this.selectedClass != "all_class") {
          this.showSelectExamOnGrade = false;
          this.getClassStudents();
        } else if (this.selectedClass == "all_class") {
          this.items = [];
          this.showSelectExamOnGrade = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    selectAll() {
      this.selectAllStudent = !this.selectAllStudent;
      this.items.forEach((el) => {
        if (el.can_edit) {
          el.selected = this.selectAllStudent;
        }
      });
    },
    cancel() {
      this.selectAllStudent = false;
      this.items.forEach((el) => {
        el.selected = this.selectAllStudent;
      });
      this.selectedExam = "";
      this.edit_mode = false;
      this.showErrorMessageForSelectExam = false;
      this.showErrorMessageStudentSelect = false;
      this.showSelectExamOnGrade = false;
      this.showErrorMessageForSelectExam = false;
    },
    // select(item) {
    //   item.selected = !item.selected;
    // },exam_name => {
    //     if (el.can_edit) {
    //       el.selected = this.selectAllStudent;
    //     }
    //   });
    // },

    getGradeClasses() {
      if (this.academic_grade_year_id != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getGradeClasses/" +
              this.academic_grade_year_id,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.classes = response.data.data;
          });
      }
    },
    getClassStudents() {
      if (this.selectedClass != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/userRelatedClassStudentsGeneralExam/" +
              this.selectedClass +
              "/" +
              this.exam_id,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.items = [];
            this.items = response.data.data;
          });
      }
    },

    getExams() {
      // /performance/activity/exams/{activityId}
      if (this.selectedActivity != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/activity/exams/" +
              this.selectedActivity,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                //the token is a variable which holds the token
              },
            }
          )
          .then((response) => {
            this.exams = [];

            this.exams = response.data.data;
          });
      }
    },
    update() {
      var errorStudentSelect = true;
      this.items.forEach((el) => {
        if (el.selected == true) {
          errorStudentSelect = false;
        }
      });
      if (this.exam_id == "") {
        this.showErrorMessageForSelectExam = true;
      } else if (errorStudentSelect == true) {
        this.showErrorMessageStudentSelect = true;
      } else {
        this.showErrorMessageStudentSelect = false;
        this.showErrorMessageForSelectExam = false;
        let data = {
          students: this.items,
          selected_exams: this.exam_id,
        };
        // console.log(data);
        axios
          .post(
            this.getApiUrl + "/performance/assign-genral-exam-to-student",
            data,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.loading = false;
            this.selectAllStudent = false;
            if (response.data.status.error == true) {
              Object.assign(
                this.validation_errors,
                response.data.status.validation_errors
              );
            } else {
              this.edit_mode = false;
              this.showErrorMessageForSelectExam = false;
              this.snack = true;
              this.snackColor = "green";
              this.snackText = "Exam Save Successfuly";
              this.getClassStudents();
            }
          });
      }
    },
    updateExamOnGrade() {
      // console.log("s");
      var exam = this.exam_id;
      var quarterId = this.quarter_id;
      var gradeId = this.academic_grade_year_id;
      if (this.exam == "") {
        this.showErrorMessageForSelectExam = true;
      } else {
        if (gradeId != "") {
          //send API
          var data = {
            exam_id: exam,
          };
          axios
            .post(
              this.getApiUrl +
                "/performance/assign-exam-to-grade-students/" +
                quarterId +
                "/" +
                gradeId,
              data,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token,
                },
              }
            )
            .then((response) => {
              this.loading = false;
              if (response.data.status.error == true) {
                this.showBulkAssignMessage = true;
              } else {
                this.edit_mode_grade = false;
                this.showErrorMessageForSelectExam = false;
                this.snack = true;
                this.snackColor = "green";
                this.snackText = "Exam Save Successfuly";
              }
            });
        }
      }
    },
    cancelTow() {
      this.edit_mode_grade = false;
      this.showErrorMessageForSelectExam = false;
      this.selectedExam = "";
    },
    getBreadCrumb() {
      // /getBreadcrumb/assign-general-exam'
      if (
        this.quarter_id != "" &&
        this.academic_grade_year_id != "" &&
        this.exam_id != ""
      ) {
        axios
          .get(
            this.getApiUrl +
              "/performance/getBreadcrumb/assign-general-exam?quarter_id=" +
              this.quarter_id +
              "&academic_grade_year_id=" +
              this.academic_grade_year_id +
              "&exam_id=" +
              this.exam_id,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.breadcrumb = response.data.data.breadcrumb;
            this.exam_name = response.data.data.exam_name;
          });
      }
    },
  },
  mounted() {
    this.academic_grade_year_id =
      this.$router.currentRoute.params.academic_grade_year_id;
    this.exam_id = this.$router.currentRoute.params.examId;
    this.quarter_id = this.$router.currentRoute.params.quarterId;
    this.getBreadCrumb();
    this.getGradeClasses();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

// end search input
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.actions-container {
  position: relative;
}
.actions {
  position: absolute;
  top: -10px;
  right: 22px;
}
.actions i,
.actions span {
  cursor: pointer;
}
.actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #eef3ff;
  margin-bottom: 33px;
}
.v-expansion-panel-content {
  background-color: #f7f7f7;
}
.title-panel {
  color: rgb(114, 151, 255);
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
.details {
  margin-top: 6%;
  overflow: hidden;
}
.details span {
  color: #8d8a8a;
  font-size: 17px;
  font-weight: 700;
}
.details span.passing {
  float: right;
}
.v-expansion-panel-content__wrap {
  padding: 0;
}
.space-name {
  margin-top: -15px !important;
}

.betweencolon {
  position: absolute;
  top: 3rem;
  left: 5%;
}

.dur-error {
  margin-top: 0 !important;
}
.maxSize {
  font-size: 10px;
}
.text-left,
.text-left th,
.text-left td {
  text-align: left !important;
}
</style>
